import apiService from '../apiService';
import { resolveUploadAssetUrl } from '@/utils/resolveUploadAssetUrl';
import { openBlobPdfInNewTab } from '@/utils/openBlobPdf';

/**
 * 取得契約簽署紀錄列表
 * @param {Object} params
 * @returns {Promise}
 */
export const getEnrollmentFlows = async (params = {}) => {
    const url = '/api/admin/enrollment-flows';
    return apiService.GET(url, params);
};

/**
 * 取得單筆契約簽署詳情
 * @param {number} id
 * @returns {Promise}
 */
export const getEnrollmentFlow = async (id) => {
    const url = `/api/admin/enrollment-flows/${id}`;
    return apiService.GET(url);
};

const signedPdfApiPath = (id) => `/api/admin/enrollment-flows/${id}/signed-pdf`;

/** 列表列用 enrollment_flow_id；詳情 API 回傳 id */
export const resolveEnrollmentFlowId = (record) =>
    record?.enrollment_flow_id ?? record?.id ?? null;

const fetchSignedPdfBlob = (id) =>
    apiService.GET(signedPdfApiPath(id), {}, { responseType: 'blob' });

const previewPdfApiPath = (id) =>
    `/api/admin/enrollment-flows/${id}/preview-pdf`;

const fetchPreviewPdfBlob = (id) =>
    apiService.GET(previewPdfApiPath(id), {}, { responseType: 'blob' });

/**
 * 透過後台 API 串流開啟 PDF（帶登入 token，不依賴 /storage 同源）
 * @param {number} id
 */
export const openEnrollmentFlowSignedPdf = async (id) =>
    openBlobPdfInNewTab(() => fetchSignedPdfBlob(id), '已簽署契約 PDF');

/**
 * 開啟契約預覽 PDF（填寫中）
 * @param {number} id enrollment_flow_id
 */
export const openEnrollmentFlowPreviewPdf = async (id) =>
    openBlobPdfInNewTab(() => fetchPreviewPdfBlob(id), '契約預覽 PDF');

/**
 * 簽名圖 API 串流（走 Bearer token，適用 GCS / 不同 origin）
 * @param {number} id enrollment_flow_id
 */
export const fetchEnrollmentSignatureImageBlob = (id) =>
    apiService.GET(
        `/api/admin/enrollment-flows/${id}/signature-image`,
        {},
        {
            responseType: 'blob'
        }
    );

/**
 * 簽名圖顯示 URL
 * 優先使用 API 回傳的完整 URL（GCS）；相對路徑改走 resolve（本地 public）
 * 正式環境建議以 fetchEnrollmentSignatureImageBlob 串流顯示。
 * @param {object} record
 * @returns {string}
 */
export const resolveEnrollmentSignatureImageUrl = (record) => {
    if (!record) {
        return '';
    }
    const direct = String(record.signature_image_url || '').trim();
    if (/^https?:\/\//i.test(direct) || /^blob:|^data:/i.test(direct)) {
        return direct;
    }
    const path = record.signature_path || direct || '';
    return resolveUploadAssetUrl(path);
};

/**
 * 是否可預覽已簽署 PDF
 * @param {object} record
 */
export const canPreviewSignedPdf = (record) =>
    Boolean(
        record?.signed_at || record?.signed_pdf_path || record?.signed_pdf_url
    );
